module.exports = __webpack_public_path__ + "static/media/v-commerce_SUB-ENG.3e02c764.mp4";